import * as types from "./types";

const getListOpdIkd_act = () => async (dispatch, getState, Api) => {
    dispatch({ type: types.GET_LISTOPD_IKD_START });
    const response = await Api.getListOpdIKD();
    if (response.status !== "failed") {
        dispatch({
            type: types.GET_LISTOPD_IKD_SUCCESS,
            payload: {
                data: response.data.result.data,
                timestamp: response.data.timestamp,
                message: response.data.result.message,
                author: response.data.author
            },
        });
    } else {
        dispatch({
            type: types.GET_LISTOPD_IKD_FAILED,
            payload: {
                message: response.error,
            },
        });
    }
}

const getDataIkdOpd_act = (idopd) => async (dispatch, getState, Api) => {
    dispatch({ type: types.GET_DATA_IKD_START });
    const response = await Api.getDataIkdOpd(idopd);
    if (response.status !== "failed") {
        dispatch({
            type: types.GET_DATA_IKD_SUCCESS,
            payload: {
                data: response.data.result.data,
                timestamp: response.data.timestamp,
                message: response.data.result.message,
                author: response.data.author
            },
        });
    } else {
        dispatch({
            type: types.GET_DATA_IKD_FAILED,
            payload: {
                message: response.error,
            },
        });
    }
}


export {
    getListOpdIkd_act,
    getDataIkdOpd_act
}